/** The minimal job shape game-ness is read from — heads and their splits. */
export interface GameJobShape {
  animalHeads?:
    | ({
        splits?:
          | ({ kind?: string | null; isDeleted?: boolean | null } | null)[]
          | null;
      } | null)[]
    | null;
}

/**
 * Whether a job is a wild-game drop-off.
 *
 * Derived from `Split.kind`, never from the species. That is deliberate and
 * load-bearing: `venison` is an ordinary species value that predates wild game
 * and a livestock job could legitimately carry it, so species would answer a
 * different question than the one being asked. `kind` is the single seam the
 * whole feature hangs off — the jobs filter, the V2-only cut sheet routing and
 * the add-animals path all read it — so they cannot disagree about what a game
 * job is.
 *
 * A job whose splits have all been removed reads as NOT game, which is correct:
 * there is nothing left to inherit from either.
 * @param job the job, with its heads' splits selected.
 * @returns true when any live split on the job is a game split.
 */
export function isGameJob(job: GameJobShape | null | undefined): boolean {
  return (job?.animalHeads ?? []).some((head) =>
    (head?.splits ?? []).some(
      (split) => split?.kind === 'game' && !split?.isDeleted,
    ),
  );
}
